import { IntlShape } from 'react-intl'

import { DataSortEnum, FiltersEnum, TravelTypeEnum } from '../../../lib/graphql'

export const getHouseSearchSortLabel = ({
  value,
  intl,
}: {
  value: DataSortEnum
  intl: IntlShape
}) => {
  switch (value) {
    case DataSortEnum.ASCENDING:
      return intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.ascendingPrice',
        defaultMessage: 'Prix croissant',
      })
    case DataSortEnum.DESCENDING:
      return intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.descendingPrice',
        defaultMessage: 'Prix décroissant',
      })
    case DataSortEnum.PERTINENT:
      return intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.pertinent',
        defaultMessage: 'Pertinence',
      })
  }
}

export const getHouseSearchSortOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.ascendingPrice',
        defaultMessage: 'Prix croissant',
      }),
      value: DataSortEnum.ASCENDING,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.descendingPrice',
        defaultMessage: 'Prix décroissant',
      }),
      value: DataSortEnum.DESCENDING,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.pertinent',
        defaultMessage: 'Pertinence',
      }),
      value: DataSortEnum.PERTINENT,
    },
  ]
}

export const getPopularFiltersOptions = (
  intl: IntlShape,
  travelType?: TravelTypeEnum,
) => {
  return [
    ...(travelType === TravelTypeEnum.CORPORATE_EVENING_EVENT
      ? []
      : [
          {
            label: intl.formatMessage({
              id: 'ui.houseSearchLayout.utils.autonomousTag',
              defaultMessage: 'Réservation instantanée',
            }),
            labelSuffix: intl.formatMessage({
              id: 'ui.houseSearchLayout.utils.suffix.autonomousTag',
              defaultMessage: 'en réservation instantanée',
            }),
            name: FiltersEnum.AUTONOMOUS_BOOKING,
          },
        ]),
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.accessByTrain',
        defaultMessage: 'Accessible à pied depuis une gare',
      }),
      labelSuffix: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.suffix.accessByTrain',
        defaultMessage: 'accessible à pied depuis une gare.',
      }),
      name: FiltersEnum.WALKING_DISTANCE_FROM_TRAIN_STATION,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.fifteenMinTrainStation',
        defaultMessage: "À moins de 15min d'une gare",
      }),
      labelSuffix: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.suffix.fifteenMinTrainStation',
        defaultMessage: "à moins de 15min d'une gare.",
      }),
      name: FiltersEnum.LESS_THAN_15_MIN_FROM_TRAIN_STATION,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.executiveRange',
        defaultMessage: 'Gamme Executive',
      }),
      labelSuffix: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.suffix.executiveRange',
        defaultMessage: 'en Gamme Executive.',
      }),
      name: FiltersEnum.EXECUTIVE,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.swimmingPool',
        defaultMessage: 'Piscine',
      }),
      labelSuffix: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.suffix.swimmingPool',
        defaultMessage: 'avec piscine.',
      }),
      name: FiltersEnum.SWIMMING_POOL,
    },
  ]
}

export const getWorkFiltersOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.meetingRoom',
        defaultMessage: 'Salle de réunion',
      }),
      name: FiltersEnum.MEETING_ROOM,
    },
  ]
}

export const getHobbyFiltersOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.spa',
        defaultMessage: 'Spa',
      }),
      name: FiltersEnum.SPA,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.bicycles',
        defaultMessage: 'Vélo(s)',
      }),
      name: FiltersEnum.BICYCLES,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.tennisCourt',
        defaultMessage: 'Terrain de tennis',
      }),
      name: FiltersEnum.TENNIS_COURT,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.petanqueOrMolky',
        defaultMessage: 'Pétanque ou Mölkky',
      }),
      name: FiltersEnum.PETANQUE_OR_MOLKY,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.tableTennis',
        defaultMessage: 'Ping pong',
      }),
      name: FiltersEnum.TABLE_TENNIS,
    },
  ]
}

export const getOtherFiltersOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.equipedKitchen',
        defaultMessage: 'Cuisine équipée',
      }),
      name: FiltersEnum.EQUIPPED_KITCHEN,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.barbecue',
        defaultMessage: 'Barbecue',
      }),
      name: FiltersEnum.BARBECUE,
    },
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.fireplace',
        defaultMessage: 'Cheminée',
      }),
      name: FiltersEnum.FIREPLACE,
    },
  ]
}

export const getRulesFiltersOptions = (intl: IntlShape) => {
  return [
    {
      label: intl.formatMessage({
        id: 'ui.houseSearchLayout.utils.petsAllowed',
        defaultMessage: 'Animaux de compagnie acceptés',
      }),
      name: FiltersEnum.PETS_ALLOWED,
    },
  ]
}
